import { render, staticRenderFns } from "./FCCDate.vue?vue&type=template&id=45a19d58"
import script from "./FCCDate.vue?vue&type=script&lang=js"
export * from "./FCCDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports